export const forgotPassword = {
    title: '비밀번호를 잊으 셨나요?',
    content: '등록된 이메일을 입력해주세요',
    button: '보내기',
    titleSwal: '비밀번호 재설정 링크를 보냈습니다.',
    contentSwal: '이메일을 확인하고 비밀번호 재설정 링크를 확인하십시오.',
};
